import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProcedureDocument } from '@completion/models';

@Component({
  selector: 'app-procedure-document-viewer',
  templateUrl: './procedure-document-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProcedureDocumentViewerComponent {
  document: ProcedureDocument | null = null;
}
